import Success from 'assets/Success.png'
import { formatPrice } from "helpers/formatNumber";
import { OrderNumberTitle, ThankYouPaidContainer, ThankYouPaidTitle, ThankYouTitle } from "../styles";

const TOPaid = ({ isWebView, oId }) => {
  const balanceDue = localStorage.getItem(`${oId}-balanceDue`);
  const orderNumber = localStorage.getItem(`orderNumber-${oId}`);


  return (
     <ThankYouPaidContainer>
       <ThankYouTitle>Thank you!</ThankYouTitle>
       {orderNumber && (
         <OrderNumberTitle>{`Order #${orderNumber}`}</OrderNumberTitle>
       )}
       <ThankYouPaidTitle>{`Paid: ${formatPrice(balanceDue)}`}</ThankYouPaidTitle>
       <img src={Success} alt="success"/>
         {!isWebView ? <ThankYouTitle>Please come again!</ThankYouTitle> : null}
     </ThankYouPaidContainer>
  )
}
export default TOPaid;